/**
 * Read-only client for the SkynetAPI ceiling-derivation aggregation endpoint (DEV-4656). Rides the
 * SkynetAPI gateway (httpSkynetApi) — NOT the Accounts subCompaniesApi host and NOT the ApplyForm
 * host — so the broker sees only the aggregated channels/templates their permission ceiling is
 * built from and never makes a direct Pricing/POS catalog call (which would 403).
 */
export class SubCompanyCeilingDerivationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // Returns { sourceChannels: [{ channelId, channelName, templates: string[] }] }. Degradable
  // broker read: skip the global forbidden-status page-reload interceptor so a failed derivation
  // fetch degrades in-panel (meter-only) instead of reloading the whole app.
  async getSubCompanyCeilingDerivation({ subCompanyId }) {
    return this.#http.get(`/api/admin-panel/sub-companies/${subCompanyId}/ceiling-derivation`, {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }
}
